import { IModuleCard } from "../../services/interface/IHome";
import RightArrow from "../../assets/rightarrow.svg"
import { Link, useNavigate } from "react-router-dom";
import { transformTitle } from "../../utils/formatter";
import { useDispatch } from "react-redux";
import { setSelectedGbpFilter, setSelectionFlag } from "../../services/redux/reducer/filter.reducer";
import { setApplyFilter, setClearState } from "../../services/redux/reducer/demandfilter.reducer";

type props = {module: IModuleCard}

export const ModuleCard=({module}:props)=>{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const navigateToHandler = (value: string | null) => {
        if (value) {
            navigate(value);
            dispatch(setSelectionFlag(false));
            dispatch(setSelectedGbpFilter({}));
            dispatch(setApplyFilter(""));
            dispatch(setClearState());
        }
    }
    return <div className="db-shadow p-[2%] py-[2%] bg-[#FFF] rounded">
        <div className="w-[100%] py-[0.4vw] px-[3%] pt-[0px] leading-none">
            <span className="text-fs20 font-semibold leading-normal">{module.title}</span>
        </div>
        <ul>
            {module.options.map((option, index) => {
                return <li className="cursor-pointer home-page-footer-title py-[2%] px-[3%] flex items-center justify-between border-t-[1px] py-[5.5px] px-[7px] hover:text-[#86bc25]" key={index} onClick={() => navigateToHandler(`${transformTitle(option)}`)}>{option}
                    <span className="home-page-footer-title">
                        {option !== "" && <img className="w-[0.5vw]" src={RightArrow} alt="Right" />}
                    </span>
                </li>
            })}
        </ul>
    </div>
}